<!-- ============================================================ -->
<!-- SINGLE ORDER LINE MODE — new vertical layout                -->
<!-- ============================================================ -->
<ng-container *ngIf="isSingleProductMode">
  <app-shared-dialog
    class="technical_dialog single-mode-dialog"
    [title]="'quotations_and_orders.matching_missing_ai_quote_products.product_matching' | translate"
    [options]="{
      size: (dialogMode === 'side_by_side' ? 'auto' : 'large'),
      titleIcon: 'link-icon',
      titleIconColor: 'primary',
      cancelText: 'common.close' | translate | uppercase,
      middleText: alwaysIgnore
        ? ('quotations_and_orders.ignore.remove_and_ignore' | translate | uppercase)
        : this.dialogMode !== 'side_by_side'
          ? ('quotations_and_orders.remove_product' | translate | uppercase)
          : '',
      middleButtonStyle: 'danger',
      confirmText: 'common.apply' | translate | uppercase,
      hideConfirmButton: alwaysIgnore,
      confirmButtonStyle: 'primary'
    }"
    (confirm)="save()"
    (cancel)="close()"
    (middle)="deleteProduct()"
  >
    <div class="single-mode-content" *ngIf="displayProducts[0] as product">
      <!-- Block 1: Extracted data -->
      <div class="section" *ngIf="product.raw_phrase">
        <div class="section-label">{{ "quotations_and_orders.matching_missing_ai_quote_products.extracted_data" | translate }}</div>
        <div class="extracted-data">
          <ui-svg-icon svgIcon="ai-volta-icon" size="small"></ui-svg-icon>
          <span>{{ product.raw_phrase }}</span>
        </div>
      </div>

      <hr class="section-divider" *ngIf="product.raw_phrase" />

      <!-- Block 2: Product matched -->
      <div class="section">
        <div class="section-label">
          {{ "quotations_and_orders.matching_missing_ai_quote_products.product_matched" | translate }}
          <img *ngIf="!originalProduct" src="assets/icones/unmatched-icon.svg" alt="" class="unmatched-warning-icon" />
        </div>

        <!-- Product card (only if there IS an original matched product) -->
        <div *ngIf="originalProduct" class="product-card" [class.product-card-selected]="isOriginalSelected()">
          <img class="product-card-img" [src]="originalProduct.image ? baseUrl + originalProduct.image + '?thumbnail=1' : placeholder" alt="" />
          <div class="product-card-info">
            <span class="product-card-name">{{ originalProduct.name }}</span>
            <span class="product-card-sku">{{ originalProduct | productCode }}</span>
          </div>
          <div class="product-card-action">
            <ng-container *ngIf="isOriginalSelected()">
              <div class="match-label-wrapper">
                <span class="match-label">{{ getOriginalLabel() }}</span>
                <span *ngIf="getOriginalSublabel()" class="match-sublabel">{{ getOriginalSublabel() }}</span>
              </div>
              <ui-svg-icon [svgIcon]="getOriginalIcon()" size="large"></ui-svg-icon>
            </ng-container>
            <button *ngIf="!isOriginalSelected()" class="select-btn" (click)="selectOriginal()">SELECT</button>
          </div>
        </div>
      </div>

      <!-- Block 3: Alternatives header -->
      <div class="section">
        <div class="section-label">
          {{ "quotations_and_orders.matching_missing_ai_quote_products.alternatives" | translate }}
          <span class="alternatives-count">{{ alternativesCount }}</span>
        </div>
      </div>

      <!-- Block 4: Search input -->
      <div class="section">
        <div class="search-box">
          <input
            type="text"
            class="search-input"
            placeholder="{{ 'quotations_and_orders.matching_missing_ai_quote_products.search_product' | translate }}"
            [matAutocomplete]="singleAuto"
            (input)="onSingleSearch($event)"
            [value]="searchInput"
            #singleSearchInput
            #singleTrigger="matAutocompleteTrigger"
          />

          <mat-autocomplete
            #singleAuto="matAutocomplete"
            (optionSelected)="onSingleProductSelect($event)"
            (opened)="onSingleAutocompleteOpened()"
            (closed)="onSingleAutocompleteClosed()"
          >
            <mat-option class="product-option" *ngFor="let p of products" [value]="p">
              <div class="product-details-block">
                <div class="product-icon">
                  <img class="col-img" [src]="p.image ? baseUrl + p.image + '?thumbnail=1' : placeholder" alt="" />
                </div>
                <div class="product-details">
                  <span class="product-name">{{ p.name }}</span>
                  <span class="product-sku">{{ p | productCode }}</span>
                </div>
              </div>
            </mat-option>
            <mat-option *ngIf="isSearchLoading" disabled class="search-loader-option">
              <div class="search-loader">
                <span class="search-spinner"></span>
              </div>
            </mat-option>
          </mat-autocomplete>

          <div class="search-icon">
            <img src="assets/icones/search-icon.svg" alt="" />
          </div>
        </div>
      </div>

      <!-- Block 5: Candidate list (alternatives + search-added) -->
      <div class="section candidates-list" *ngIf="candidateProducts.length > 0">
        <div *ngFor="let candidate of candidateProducts" class="product-card" [class.product-card-selected]="isCandidateSelected(candidate)">
          <img class="product-card-img" [src]="candidate.image ? baseUrl + candidate.image + '?thumbnail=1' : placeholder" alt="" />
          <div class="product-card-info">
            <span class="product-card-name">{{ candidate.name }}</span>
            <span class="product-card-sku">{{ candidate | productCode }}</span>
            <span *ngIf="isOriginalCandidate(candidate)" class="original-product-badge">{{ "quotations_and_orders.match_method.original_product" | translate }}</span>
          </div>
          <div class="product-card-action">
            <ng-container *ngIf="isCandidateSelected(candidate)">
              <span class="match-label">{{ "quotations_and_orders.match_method.manual_match" | translate }}</span>
              <ui-svg-icon svgIcon="manual-match-icon" size="medium"></ui-svg-icon>
            </ng-container>
            <button *ngIf="!isCandidateSelected(candidate)" class="select-btn" (click)="selectCandidate(candidate)">SELECT</button>
          </div>
        </div>
      </div>

      <div class="no-candidates">
        <!-- AMTW bar: cascade_only — no toggle, automatic repoint notice -->
        <div
          class="amtw-toggle-bar"
          *ngIf="amtwMode === 'cascade_only' && selectedProductId && selectedProductId !== originalProduct?.id && !amtwBlockedByMissingCustomer"
        >
          <ui-svg-icon class="amtw-toggle-bar__icon" svgIcon="ai-volta-icon" size="small"></ui-svg-icon>
          <div class="amtw-toggle-bar__copy">
            <div class="amtw-toggle-bar__help">
              {{ "quotations_and_orders.amtw.help_cascade_extref" | translate }}
            </div>
          </div>
        </div>

        <!-- AMTW bar: cascade_plus_options / full — with toggle -->
        <!--
          FTUE anchor: mounts with the bar itself, so the "make that match stick"
          tip can only appear when the toggle it talks about is on screen.
        -->
        <div class="amtw-toggle-bar" *ngIf="showAlwaysMatchToggle"
             [appFtueAnchor]="ftueAnchors.ORDER_LINE_ALWAYS_MATCH">
          <ui-svg-icon class="amtw-toggle-bar__icon" svgIcon="ai-volta-icon" size="small"></ui-svg-icon>
          <div class="amtw-toggle-bar__copy">
            <!-- Title with single code as plain text -->
            <div class="amtw-toggle-bar__title" *ngIf="hasExtractedCodes && extractedCodesList.length === 1">
              <span [innerHTML]="'quotations_and_orders.amtw.title_with_code' | translate: { product: selectedProductName }"></span>
              <strong class="amtw-toggle-bar__code-text">{{ extractedCodesList[0] }}</strong>
            </div>

            <!-- Title with inline code selector for 2+ codes -->
            <div class="amtw-toggle-bar__title" *ngIf="hasExtractedCodes && extractedCodesList.length > 1">
              <span [innerHTML]="'quotations_and_orders.amtw.title_with_code' | translate: { product: selectedProductName }"></span>
              <select class="amtw-toggle-bar__inline-code" [(ngModel)]="selectedAmtwCode" data-test="amtw-code-picker">
                <option *ngFor="let code of extractedCodesList" [ngValue]="code">{{ code }}</option>
              </select>
            </div>

            <!-- Title without code (alias-only path) -->
            <div
              class="amtw-toggle-bar__title"
              *ngIf="!hasExtractedCodes"
              [innerHTML]="'quotations_and_orders.amtw.title' | translate: { product: selectedProductName, key: customerKey }"
            ></div>

            <!-- Help text -->
            <div class="amtw-toggle-bar__help">
              {{ amtwHelpKey | translate: amtwHelpParams }}
            </div>

            <!-- Override notice for cascade_plus_options (alias auto-update) -->
            <div *ngIf="amtwOverrideNoticeKey as noticeKey" class="amtw-toggle-bar__notice">
              <ui-svg-icon svgIcon="alert-circle" size="medium"></ui-svg-icon>
              <span [innerHTML]="noticeKey | translate: amtwOverrideNoticeParams"></span>
            </div>
          </div>

          <mat-slide-toggle [(ngModel)]="alwaysMatch" color="primary" class="amtw-toggle-bar__switch" data-test="amtw-toggle"> </mat-slide-toggle>
        </div>

        <!-- Ignore bar: shown when unmatched, no product selected, codes exist (D-01, D-02, D-09) -->
        <div class="ignore-toggle-bar" *ngIf="showAlwaysIgnoreToggle">
          <ui-svg-icon class="ignore-toggle-bar__icon" svgIcon="clipboard-x" size="medium"></ui-svg-icon>
          <div class="ignore-toggle-bar__copy">
            <!-- Single code + has extracted name (D-03) -->
            <div class="ignore-toggle-bar__title" *ngIf="extractedCodesList.length === 1 && displayProducts[0]?.ai_extracted_name">
              <span
                [innerHTML]="
                  'quotations_and_orders.ignore.title_with_code' | translate: { code: extractedCodesList[0], name: displayProducts[0]?.ai_extracted_name }
                "
              ></span>
            </div>

            <!-- Single code + no extracted name (D-03 fallback) -->
            <div class="ignore-toggle-bar__title" *ngIf="extractedCodesList.length === 1 && !displayProducts[0]?.ai_extracted_name">
              <span [innerHTML]="'quotations_and_orders.ignore.title_code_only' | translate: { code: extractedCodesList[0] }"></span>
            </div>

            <!-- Multi-code: inline selector (D-08) -->
            <div class="ignore-toggle-bar__title" *ngIf="extractedCodesList.length > 1">
              <span>{{ "quotations_and_orders.ignore.title_multi_prefix" | translate }}</span>
              <select class="ignore-toggle-bar__inline-code" [(ngModel)]="selectedIgnoreCode" data-test="ignore-code-picker">
                <option *ngFor="let code of extractedCodesList" [ngValue]="code">{{ code }}</option>
              </select>
              <span>{{ "quotations_and_orders.ignore.title_multi_suffix" | translate }}</span>
            </div>

            <!-- Help text -->
            <div class="ignore-toggle-bar__help">
              {{ "quotations_and_orders.ignore.help" | translate }}
            </div>
          </div>

          <mat-slide-toggle [(ngModel)]="alwaysIgnore" class="ignore-toggle-bar__switch" data-test="ignore-toggle"> </mat-slide-toggle>
        </div>
      </div>
    </div>
  </app-shared-dialog>
</ng-container>

<!-- ============================================================ -->
<!-- UNMATCHED AI MODE — legacy two-column layout (unchanged)     -->
<!-- ============================================================ -->
<ng-container *ngIf="!isSingleProductMode">
  <app-shared-dialog
    class="technical_dialog"
    [title]="'quotations_and_orders.matching_missing_ai_quote_products.product_matching' | translate"
    [options]="{
      size: 'large',
      titleIcon: 'link-icon',
      titleIconColor: 'primary',
      confirmText: 'common.proceed' | translate | uppercase,
      cancelText: 'common.cancel' | translate | uppercase,
      confirmButtonStyle: 'primary'
    }"
    (confirm)="save()"
    (cancel)="close()"
  >
    <div class="dialog-content">
      <div class="product-list-container-header">
        <span>{{ "quotations_and_orders.matching_missing_ai_quote_products.conflicting_products" | translate }}</span>
        <span [class.prd-count]="data.mode === 'unmatched_ai'">{{ displayProducts.length || 0 }}</span>
      </div>
      <div class="product-list-container-content" *ngIf="displayProducts && displayProducts.length > 0">
        <div class="product-list-container-content-header">
          <div>
            <span>{{ "quotations_and_orders.matching_missing_ai_quote_products.products_found" | translate }}</span>
          </div>
          <div>
            <span>{{ "quotations_and_orders.matching_missing_ai_quote_products.volta_product" | translate }}</span>
          </div>
        </div>
        <div class="product-list-container">
          <div class="product-item" *ngFor="let product of displayProducts">
            <div>
              <div *ngIf="product.raw_phrase" class="potential-alternatives">
                <ui-svg-icon svgIcon="ai-volta-icon" size="small"></ui-svg-icon>
                <span title="{{ product.raw_phrase }}" class="raw_phrase_text">{{ product.raw_phrase }}</span>
              </div>
              <div class="unmatch-products">
                <div class="product-icon">
                  <img [src]="product.image ? baseUrl + product.image + '?thumbnail=1' : placeholder" alt="" />
                </div>
                <div class="product-details">
                  <span class="product-name">{{ product.ai_extracted_name }}</span>
                  <span class="product-sku">{{ product.description || "--" }}</span>
                </div>
              </div>
            </div>
            <div class="match-products">
              <div class="match-products-container">
                <div class="search-box">
                  <!-- Show selected product as tag -->
                  <div class="selected-product-tag" *ngIf="hasSelectedProduct(product.name)">
                    <span class="product-tag-name">{{ getSelectedProductName(product.name) }}</span>
                    <button class="remove-tag-btn" (click)="removeSelectedProduct(product.name)">
                      <img src="assets/icones/close.svg" alt="Remove" />
                    </button>
                  </div>

                  <!-- Show search input when no product is selected -->
                  <input
                    type="text"
                    class="search-input"
                    placeholder="{{ 'quotations_and_orders.matching_missing_ai_quote_products.search_product' | translate }}"
                    [matAutocomplete]="auto"
                    (input)="onSearch($event, product.name)"
                    (focus)="onInputFocus(product.name, trigger)"
                    [value]="getSearchInputValue(product.name)"
                    #searchInput
                    #trigger="matAutocompleteTrigger"
                    *ngIf="!hasSelectedProduct(product.name)"
                  />

                  <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="onProductSelect($event)"
                    (opened)="onAutocompleteOpened()"
                    (closed)="onAutocompleteClosed()"
                  >
                    <mat-option class="product-option" *ngFor="let voltaProduct of products" [value]="voltaProduct">
                      <div class="product-details-block">
                        <div class="product-icon">
                          <img class="col-img" [src]="voltaProduct.image ? baseUrl + voltaProduct.image + '?thumbnail=1' : placeholder" alt="" />
                        </div>
                        <div class="product-details">
                          <span class="product-name">{{ voltaProduct.name }}</span>
                          <span class="product-sku">{{ voltaProduct | productCode }}</span>
                        </div>
                      </div>
                    </mat-option>
                    <mat-option *ngIf="isSearchLoading" disabled class="search-loader-option">
                      <div class="search-loader">
                        <span class="search-spinner"></span>
                      </div>
                    </mat-option>
                  </mat-autocomplete>
                  <div class="search-icon" *ngIf="!hasSelectedProduct(product.name)">
                    <img src="assets/icones/search-icon.svg" alt="" />
                  </div>
                </div>
              </div>
              <button class="remove-product-btn" (click)="removeProduct(product.name)">
                <img src="assets/icones/delete-icon-red.svg" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="product-list-container-content" *ngIf="displayProducts.length === 0">
        <div class="product-list-container-content-header">
          <span>{{ "quotations_and_orders.matching_missing_ai_quote_products.no_products_found" | translate }}</span>
        </div>
      </div>
    </div>
  </app-shared-dialog>
</ng-container>